import type { ProductFeatureDefinition } from "./product-feature-definition";

/**
 * Catalog entries for campaigns and messages, the inbox, scoring, signals, analytics and the
 * knowledge base (PREC-4329). A campaign send is one feature per channel, because the channels are
 * set up and adopted separately; a manual send is one feature (Compose), whatever its channel.
 */
export const OUTREACH_PRODUCT_FEATURES = [
	{
		key: "campaigns-overview",
		label: "Campaigns overview",
		area: "Outreach",
		surfaces: ["web", "mcp"],
		featureCode: "CAMPAIGNS_OVERVIEW",
	},
	{
		key: "campaign-builder",
		label: "Campaign builder",
		area: "Outreach",
		surfaces: ["web", "mcp"],
		featureCode: "SEQUENCER",
	},
	{
		key: "campaign-activation",
		label: "Campaign start and pause",
		area: "Outreach",
		surfaces: ["web", "mcp"],
		featureCode: "SEQUENCER",
	},
	{
		key: "campaign-leads",
		label: "Campaign leads",
		area: "Outreach",
		surfaces: ["web", "mcp"],
		featureCode: "SEQUENCER",
	},
	{ key: "campaign-email", label: "Campaign email", area: "Outreach", surfaces: ["api"] },
	{
		key: "campaign-linkedin-invite",
		label: "Campaign LinkedIn invite",
		area: "Outreach",
		surfaces: ["api"],
	},
	{
		key: "campaign-linkedin-message",
		label: "Campaign LinkedIn message",
		area: "Outreach",
		surfaces: ["api"],
	},
	{
		key: "campaign-linkedin-inmail",
		label: "Campaign LinkedIn InMail",
		area: "Outreach",
		surfaces: ["api"],
	},
	{
		key: "campaign-linkedin-profile-visit",
		label: "Campaign LinkedIn profile visit",
		area: "Outreach",
		surfaces: ["api"],
	},
	{
		key: "ready-to-send",
		label: "Ready to send (AI draft review)",
		area: "Outreach",
		surfaces: ["web", "mcp"],
		featureCode: "SEQUENCER",
	},
	{
		key: "outbox",
		label: "Outbox",
		area: "Outreach",
		surfaces: ["web", "mcp"],
		featureCode: "SEQUENCER",
	},
	{
		key: "compose",
		label: "Compose (manual message)",
		area: "Outreach",
		surfaces: ["web", "mcp", "extension"],
		featureCode: "SEQUENCER",
	},
	{
		key: "ai-copywriting",
		label: "AI copywriting",
		area: "Outreach",
		surfaces: ["web", "mcp", "api"],
	},
	{
		key: "copywriting-settings",
		label: "Copywriting settings",
		area: "Outreach",
		surfaces: ["web"],
		featureCode: "COPYWRITING_SETTINGS",
	},
	{
		key: "message-templates",
		label: "Message templates",
		area: "Outreach",
		surfaces: ["web"],
		featureCode: "TEMPLATES",
	},
	{
		key: "ai-snippet",
		label: "AI snippet",
		area: "Outreach",
		surfaces: ["web"],
		featureCode: "AI_SNIPPET",
	},
	{
		key: "inbox",
		label: "Inbox",
		area: "Inbox",
		surfaces: ["web", "mcp"],
		featureCode: "SEQUENCER",
	},
	{
		key: "conversation-import",
		label: "Conversation import",
		area: "Inbox",
		surfaces: ["web"],
	},
	{
		key: "positive-reply-tracking",
		label: "Positive-reply tracking",
		area: "Inbox",
		surfaces: ["web", "api"],
	},
	{
		key: "lead-scoring-setup",
		label: "Lead scoring setup",
		area: "Scoring",
		surfaces: ["web", "mcp"],
		featureCode: "LEAD_SCORING",
	},
	{
		key: "lead-scoring-overview",
		label: "Lead scoring overview and change log",
		area: "Scoring",
		surfaces: ["web"],
		featureCode: "LEAD_SCORING",
	},
	{
		key: "lead-score",
		label: "Lead score and rescore",
		area: "Scoring",
		surfaces: ["web", "mcp"],
	},
	{
		key: "job-title-screening",
		label: "Job title screening",
		area: "Scoring",
		surfaces: ["web"],
		featureCode: "JOB_TITLE_SCREENING",
	},
	{
		key: "signals",
		label: "Signals",
		area: "Signals",
		surfaces: ["web", "mcp", "extension"],
		featureCode: "TRACKER_AS_LIST",
	},
	{ key: "feed", label: "Feed", area: "Signals", surfaces: ["web", "mcp"] },
	{
		key: "profile-tracker",
		label: "Profile tracker",
		area: "Signals",
		surfaces: ["web", "extension", "mcp"],
	},
	{
		key: "signal-config",
		label: "Signal configuration",
		area: "Signals",
		surfaces: ["web", "mcp"],
	},
	{ key: "signal-scoring", label: "Signal scoring", area: "Signals", surfaces: ["api"] },
	{
		key: "analytics",
		label: "Analytics",
		area: "Analytics",
		surfaces: ["web", "mcp"],
		featureCode: "LEAD_SCORING",
	},
	{
		key: "dashboard",
		label: "Dashboard",
		area: "Analytics",
		surfaces: ["web", "extension", "mcp"],
	},
	{
		key: "knowledge-base",
		label: "Knowledge base",
		area: "Knowledge Base",
		surfaces: ["web", "mcp"],
		featureCode: "KNOWLEDGE_DB",
	},
] as const satisfies readonly ProductFeatureDefinition[];
